//shamelessly stolen from: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/react-sample-app/src/auth-utils.js
import { UserAgentApplication } from 'msal';

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ') > -1;
  const msie11 = ua.indexOf('Trident/') > -1;

  return msie || msie11;
}

export const msalApp = new UserAgentApplication({
  auth: {
    clientId: '6c081664-a865-4f85-9f4b-204b5ffd74a5',
    authority: 'https://login.microsoftonline.com/472b74d2-8f88-4a04-9045-8555a029a468',
    validateAuthority: true,
    redirectUri: 'https://teamsapp.hortskills.com.au/',
    postLogoutRedirectUri: 'https://teamsapp.hortskills.com.au/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: isIE()
  },
  system: {
    navigateFrameWait: 0
  }
});
